import { uniq } from 'lodash';
import React, {
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState
} from 'react';

interface IVerifiedDomainsValue {
	verifiedDomains: string[];
	addVerifiedDomain: (domain: string) => void;
}

const VerifiedDomains = createContext<IVerifiedDomainsValue | undefined>(
	undefined
);

interface IVerifiedDomainsProviderProps {
	children: React.ReactNode;
	initialVerifiedDomains?: string[];
}

export const VerifiedDomainsProvider: React.FC<
	IVerifiedDomainsProviderProps
> = ({ children, initialVerifiedDomains = [] }) => {
	const [verifiedDomains, setVerifiedDomains] = useState<string[]>(
		initialVerifiedDomains
	);
	const addVerifiedDomain = useCallback((domain: string) => {
		setVerifiedDomains((d) => uniq([...d, domain]));
	}, []);

	const value = useMemo(
		() => ({ verifiedDomains, addVerifiedDomain }),
		[addVerifiedDomain, verifiedDomains]
	);

	return (
		<VerifiedDomains.Provider value={value}>
			{children}
		</VerifiedDomains.Provider>
	);
};

export const useVerifiedDomains = (): IVerifiedDomainsValue => {
	const context = useContext(VerifiedDomains);
	if (!context) throw new Error('VerifiedDomainsProvider is missing');
	return context;
};
